import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isDropdownPermission } from '../../Hooks/permissionsMiddleware';
import { useOutletsQuery } from '../../Store/Apis/outletApi';

const AddEditBrand = ({ onSubmit, data }) => {
  const [category, setCategory] = useState(data?.category || '');
  const [brandName, setBrandName] = useState(data?.brandName || '');
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(data?.logo || '');
  const servicesList = useOutletsQuery()
  const user = useSelector((state) => state.auth.user);

  // Handle file input change and convert to Base64
  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogo(reader.result);
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({ category, brandName, logo });
  };
  
  useEffect(() => {
    if (user.role !== 'superAdmin') {
      setCategory(user.outletID);
    }
  }, []);




  return (
    <form onSubmit={handleSubmit} className="">
      <div className="mb-3">
        <label htmlFor="category" className="form-label">Category</label>
        <select
          id="category"
          className="form-select"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          required
          disabled={(servicesList.isSuccess === true && !isDropdownPermission(user.role_Id))}
        >
          <option value="">Select a Category</option>
          {
                servicesList?.data?.data.map((elem, i)=> {
                    return (<option value={elem.outletId} key={i}>{elem.outletName}</option>)
                })
            }
        </select>
      </div>

      <div className="mb-3">
        <label htmlFor="brandName" className="form-label">Brand Name</label>
        <input
          type="text"
          className="form-control"
          id="brandName"
          value={brandName}
          onChange={(e) => setBrandName(e.target.value)}
          required
        />
      </div>

      <div className="mb-3">
        <label htmlFor="logo" className="form-label">Logo</label>
        <input
          type="file"
          className="form-control"
          id="logo"
          accept="image/*"
          onChange={handleLogoChange}
          required
        />
        {logoPreview && (
          <div className="mt-3">
            <img src={logoPreview} alt="Logo Preview" className="img-thumbnail" style={{ maxWidth: '150px' }} />
          </div>
        )}
      </div>

      <button type="submit" className="btn btn-primary">
        {data ? 'Update Brand' : 'Create Brand'}
      </button>
    </form>
  );
};

export default AddEditBrand;